import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import NewsCard from '../components/NewsCard';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { selectAllNews, selectNewsStatus } from '../redux/newsSlice';
import { Box, Container, Typography, Grid, CircularProgress, Alert } from '@mui/material';

function News() {
  const navigate = useNavigate();
  const news = useSelector(selectAllNews);
  const status = useSelector(selectNewsStatus);

  const loading = status === 'loading' || status === 'idle';
  const error = useSelector((state) => state.news.error);

  const handleNewsClick = (newsId) => {
    navigate(`/news/${newsId}`);
  };

  return (
    <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', position: 'relative' }}>
      <PageHeader
        title="Latest News"
        backgroundImage="/images/headers/news_bg.jpeg"
        subtitle="Deep dives into championships, technical insights, and community highlights from the global Gymkhana circuit."
      />

      {/* Decorative Watermark */}
      <Typography
        variant="h1"
        sx={{
          position: 'fixed',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: { xs: '8rem', md: '20rem' },
          fontWeight: 900,
          color: 'rgba(79, 70, 229, 0.02)',
          zIndex: 0,
          pointerEvents: 'none',
          fontFamily: 'Bebas Neue',
          whiteSpace: 'nowrap',
          userSelect: 'none'
        }}
      >
        NEWS_GRID
      </Typography>

      <Container maxWidth="xl" sx={{ py: 12, position: 'relative', zIndex: 1 }}>
        {loading && news.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
            <CircularProgress sx={{ color: '#4f46e5' }} />
          </Box>
        ) : error ? (
          <Box sx={{ py: 4 }}>
            <Alert severity="error" sx={{ borderRadius: 4 }}>{error}</Alert>
          </Box>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <Grid container spacing={4}>
              {news.map((item, index) => (
                <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={item.id}>
                  <NewsCard
                    content={item?.content}
                    image={item?.imageUrl}
                    title={item?.title}
                    date={item?.date}
                    index={index}
                    onClick={() => handleNewsClick(item.id)}
                  />
                </Grid>
              ))}
            </Grid>
          </motion.div>
        )}
      </Container>
    </Box>
  );
}

export default News;
